import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { Url } from "@/helpers/url";
import { Icon } from "@/elements-react/fix-icon";
import { FixButton } from "@/elements-react/fix-button";

export interface ShortProduct {
  id: string;
  mpnFormatted: string;
  brand: { name: string };
  productInfo: { name: string };
  productAssets?: { type: string; path: string }[];
}

export interface ExchangeOfferProps {
  shortProduct: ShortProduct;
  dispatchSelectedQuantity: number;
  afterExchangeAdded?: () => void;
  className?: string;
}

const ExchangeOffer: React.FC<ExchangeOfferProps> = ({ shortProduct, dispatchSelectedQuantity, afterExchangeAdded, className }) => {
  const { t } = useTranslation();

  const imgUrl = shortProduct.productAssets?.find((a) => a.type === "image")?.path || "/no-image-product.svg";

  const handleAdd = () => {
    // Add exchange logic here
    if (afterExchangeAdded) afterExchangeAdded();
  };

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.iconWrap}>
        <Icon name="arrow-repeat" className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{t("exchange-offer.title", "Alternative offer")}</div>
        <div className={styles.product}>
          <div className={styles.imgWrap}>
            <img src={imgUrl} alt="" className={styles.img} />
          </div>
          <div className={styles.info}>
            <a className={styles.link} href={Url.to("product-page", { id: shortProduct.id })} target="_blank" rel="noopener noreferrer">
              {shortProduct.mpnFormatted} {shortProduct.brand.name} {shortProduct.productInfo.name}
            </a>
            <div className={styles.qty}>
              {t("exchange-offer.qty", "Quantity")}: {dispatchSelectedQuantity}
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          <FixButton className={styles.addBtn} variant="primary" onClick={handleAdd}>
            {t("exchange-offer.add", "Add to cart")}
          </FixButton>
        </div>
      </div>
    </div>
  );
};

export default ExchangeOffer;
